module.exports = __webpack_public_path__ + "static/media/bug.400491ce.svg";